import type { EntityLabels } from "../../i18n/EntityLabelsProvider";

/** Resolve `{customer}` / `{customers}` / `{project}` / `{projects}` in permission labels. */
export function resolvePermissionLabel(
  template: string,
  labels: EntityLabels,
): string {
  return template
    .replaceAll("{customers}", labels.customers)
    .replaceAll("{customer}", labels.customer)
    .replaceAll("{projects}", labels.projects)
    .replaceAll("{project}", labels.project);
}
